import React, { useState } from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Table, TableHead, TableRow, TableCell, TableBody, IconButton } from "@mui/material";
import HeaderCard from "./HeaderCard"; // Ensure this component exists
import CloseIcon from '@mui/icons-material/Close';


interface InventoryItem {
    itemId: number | string;
  name: string;
  quantity: number | string;
}

interface PopupContainerProps {
  open: boolean;
  onClose: () => void;
  items: InventoryItem[];
  title: string;
}

const PopupContainer: React.FC<PopupContainerProps> = ({ open, onClose, items, title }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "center",
          fontWeight: "bold",
          fontSize: "1.5rem",
          color: (theme) => theme.palette.primary.main,
          textDecoration: "underline",
        }}
      >
        {title}
      </DialogTitle>
      <DialogContent>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell><strong>ID</strong></TableCell>
              <TableCell><strong>Name</strong></TableCell>
              <TableCell><strong>Quantity</strong></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {items.map((item) => (
              <TableRow key={item.itemId}>
                <TableCell>{item?.itemId}</TableCell>
                <TableCell>{item?.name}</TableCell>
                <TableCell>{item?.quantity}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </DialogContent>
      <IconButton
        aria-label="close"
        onClick={onClose}
        sx={{
          position: "absolute",
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <CloseIcon />
      </IconButton>
    </Dialog>
  );
};

export default PopupContainer;